import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var CheckboxGroupsItemChangeModelLazy = /*#__PURE__*/function () {
  function CheckboxGroupsItemChangeModelLazy(checkboxGroupItemChangeModel, calcAllItems) {
    _classCallCheck(this, CheckboxGroupsItemChangeModelLazy);

    _defineProperty(this, "checkboxGroupItemChangeModel", void 0);

    _defineProperty(this, "calcAllItems", void 0);

    _defineProperty(this, "_allItems", void 0);

    this.checkboxGroupItemChangeModel = checkboxGroupItemChangeModel;
    this.calcAllItems = calcAllItems;
  }

  _createClass(CheckboxGroupsItemChangeModelLazy, [{
    key: "allItems",
    get: function get() {
      var _this$_allItems;

      (_this$_allItems = this._allItems) !== null && _this$_allItems !== void 0 ? _this$_allItems : this._allItems = this.calcAllItems();
      return this._allItems;
    }
  }]);

  return CheckboxGroupsItemChangeModelLazy;
}();